import React, { useContext, useState } from "react";
import { Modal } from "../dumb-components";

const ModalContext = React.createContext();

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);

  function openModal(content) {
    setContent(content);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const ModalStyle = {
    ModalContent: ({ children }) => <>{children}</>
  }

  return (
    <ModalContext.Provider
      value={{
        openModal: openModal,
        closeModal: closeModal,
        modalIsOpen: isOpen,
        ModalStyle,
        content,
      }}
    >
      <Modal />
      {children}
    </ModalContext.Provider>
  );
};


export const ModalConsumer = ModalContext.Consumer;

export function useModal() {
  return useContext(ModalContext);
}

export default ModalContext;
